<ziro-top-nav></ziro-top-nav>
<div data-automation="ziro-search" class="container-fluid">
  <div class="col-md-8 offset-md-2 py-3">
    @if (!isHosted) {
      <h2 class="d-flex my-3 align-items-center">
        <ziro-stacked-icon
          class="icon-sm"
          [stackedIcon]="ZiroStackedIcons[ziroIcons.SEARCH_CIRCLED]"
          parentClass="fa-stack me-1"
        ></ziro-stacked-icon>
        <div class="d-flex flex-column">
          <span class="vertical-align-middle">{{ 'tkey;search.header' | translate }}</span>
        </div>
      </h2>
    }

    @if (isHosted) {
      <div data-automation="search-header" class="zpm-header">
        <span
          data-automation="search-header-title"
          class="header__title"
          [ngClass]="{ 'pb-1': !query || query.length < 3 }"
        >
          {{ 'tkey;search.header' | translate }}
        </span>
        @if (query && query.length >= 3) {
          <div data-automation="search-counts-inline" class="pb-1">
            @if (zpmResultsLoading()) {
              <ngx-skeleton-loader
                class="w-100 h-100 d-flex align-items-center"
                count="1"
                appearance="line"
              ></ngx-skeleton-loader>
            } @else {
              <span class="font-size-14 font-regular me-2">
                @if (zpmTotalResults === 0) {
                  <span>{{ 'tkey;search.zero_results' | translate }}</span>
                } @else if (zpmTotalResults === 1) {
                  <span>1 {{ 'tkey;search.result' | translate }}</span>
                } @else {
                  <span>{{ zpmTotalResults }} {{ 'tkey;search.results' | translate }}</span>
                }
              </span>

              @if (resultsSummaryParts.length > 0) {
                <span class="font-size-14 font-light">
                  @for (part of resultsSummaryParts; track part.label) {
                    <span class="me-2">
                      <span>{{ part.label }}</span>
                    </span>
                  }
                </span>
              }
            }
          </div>
        }
      </div>
    }

    @if (!query || query.length < 3) {
      <div class="alert alert-danger" data-automation="no-query-warning">
        <strong>{{ 'tkey;search.query.too.small.text' | translate }}</strong>
      </div>
    } @else {
      @if (!isHosted && Number.isFinite(zpcTotalResults)) {
        <h5 data-automation="search-result-summary" class="mb-4">
          <span>
            {{
              (zpcTotalResults === 1 ? 'tkey;search.summary.one_found.text' : 'tkey;search.summary.text')
                | translate: { results: zpcTotalResults }
            }}
          </span>
        </h5>
      }

      @if (
        isHosted && !zpmResultsLoadingState.microsoftEndUserResultsLoading() && microsoftEndUserResults?.length === 250
      ) {
        <h5 data-automation="search-result-summary" class="mb-4">
          {{ 'tkey;search.summary.top.text' | translate }}
        </h5>
      }

      @if (!isHosted) {
        <div>
          @if (cucmEndUserResults?.length > 0) {
            <!-- CUCM Users -->
            <ziro-search-result-section
              data-automation="search-result-section-cucm-users"
              [heading]="'tkey;search.users.section.header'"
              [resultsCount]="cucmEndUserResults?.length"
            >
              @for (result of cucmEndUserResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.USER"
                  [description]="getCucmEndUserDescription(result)"
                  [edit]="{
                    link: '/user/' + result.ref.username,
                    tooltip: getCucmEndUserTooltip(result),
                    isDisabled: usernameHasSpaces(result) || result.isDisabled,
                  }"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (phoneResults?.length > 0) {
            <!-- Phones -->
            <ziro-search-result-section
              data-automation="search-result-section-phones"
              [heading]="'tkey;search.phones.section.header'"
              [resultsCount]="phoneResults?.length"
            >
              @for (result of phoneResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="getPhoneIcon(result)"
                  [description]="getPhoneDescription(result)"
                  [edit]="{
                    link: getPhoneEditLink(result),
                    isDisabled: getPhoneEditLinkState(result).isDisabled,
                    tooltip: getPhoneEditLinkState(result).disabledTooltip,
                  }"
                  [delete]="{
                    isDeletable: true,
                    isDisabled: false,
                  }"
                  [devicePoolSites]="devicePoolSites"
                  (deleteClicked)="onPhoneDeleteClicked($event)"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (directoryNumberResults?.length > 0) {
            <!-- Directory Numbers -->
            <ziro-search-result-section
              data-automation="search-result-section-dns"
              [heading]="'tkey;search.directory.numbers.section.header'"
              [resultsCount]="directoryNumberResults?.length"
            >
              @for (result of directoryNumberResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.PRIMARY_EXT_SMALL"
                  [description]="getDnDescription(result)"
                  [delete]="{
                    isDeletable: true,
                  }"
                  (deleteClicked)="onDnDeleteClicked($event)"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (voicemailResults?.length > 0) {
            <!-- Voicemails -->
            <ziro-search-result-section
              data-automation="search-result-section-voicemail"
              [heading]="'tkey;search.voicemails.section.header'"
              [resultsCount]="voicemailResults?.length"
            >
              @for (result of voicemailResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.VOICEMAIL_SMALL"
                  [description]="getVoicemailDescription(result)"
                  [pinReset]="{
                    link: getPinResetLink(result),
                    tooltip: 'tkey;search.pin.reset.button',
                  }"
                  [delete]="{
                    isDeletable: true,
                  }"
                  (deleteClicked)="onVoicemailDeleteClicked($event)"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (distributionListResults?.length > 0) {
            <!-- Distribution Lists -->
            <ziro-search-result-section
              data-automation="search-result-section-distribution-lists"
              [heading]="'tkey;search.distribution.lists.section.header'"
              [resultsCount]="distributionListResults?.length"
            >
              @for (result of distributionListResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.DISTRIBUTION_LIST_SMALL"
                  [description]="getDistributionListDescription(result)"
                  [edit]="{
                    link: '/server/' + result.ref.serverId + '/distribution-list/' + result.ref.id,
                  }"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (snrResults?.length > 0) {
            <!-- SNR Profiles -->
            <ziro-search-result-section
              data-automation="search-result-section-snr-profiles"
              [heading]="'tkey;search.snr.section.header'"
              [resultsCount]="snrResults?.length"
            >
              @for (result of snrResults; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.SNR_SOLID"
                  [description]="getSnrDescription(result)"
                  [edit]="{
                    link: '/user/' + result.owner?.username + '/snr/' + result.ref.id,
                    isDisabled: getPhoneEditLinkState(result).isDisabled,
                    tooltip: getPhoneEditLinkState(result).disabledTooltip,
                  }"
                  [delete]="{
                    isDeletable: true,
                    isDisabled: !result.owner,
                  }"
                  [devicePoolSites]="devicePoolSites"
                  (deleteClicked)="onSnrDeleteClicked($event)"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }

          @if (extensionMobilityProfiles?.length > 0) {
            <!-- Extension Mobility -->
            <ziro-search-result-section
              data-automation="search-result-section-extension-mobility"
              [heading]="'tkey;search.extension_mobility_profiles.section.header'"
              [resultsCount]="extensionMobilityProfiles?.length"
            >
              @for (result of extensionMobilityProfiles; track result) {
                <ziro-cisco-search-result
                  [result]="result"
                  [icon]="ziroIcons.EXTENSION_MOBILITY_SMALL"
                  [description]="getExtensionMobilityProfileDescription(result)"
                  [delete]="{
                    isDeletable: true,
                  }"
                  (deleteClicked)="onExtensionMobilityProfileDeleteClicked($event)"
                ></ziro-cisco-search-result>
              }
            </ziro-search-result-section>
          }
        </div>
      } @else {
        @if (!isLoading) {
          @if (isTeamsUserManagementAllowed) {
            <!-- Microsoft Users -->
            <ziro-collapsible-section-card
              [title]="'tkey;admin.teams_location_management.users.title' | translate"
              [count]="microsoftEndUserResults?.length ?? 0"
              [icon]="ziroIcons.USER"
              [hasLoadingState]="true"
              [isLoadingInput]="zpmResultsLoadingState.microsoftEndUserResultsLoading()"
              [dataAutomation]="'search-result-section-microsoft-users'"
              [isOpenInput]="
                zpmResultsLoadingState.microsoftEndUserResultsLoading() ||
                (!!microsoftEndUserResults?.length && microsoftEndUserResults.length > 0)
              "
              [isCollapsible]="true"
              [showChevron]="true"
            >
              @if (microsoftEndUserResults?.length > 0) {
                <div data-automation="microsoft-users-list" class="microsoft-search-table">
                  <!-- Column Headers -->
                  <div class="microsoft-search-table__header px-0 border-bottom btn border-0 text-start">
                    <div class="header__display-name">
                      <strong>{{ 'tkey;search.ms_users.results.displayname.header' | translate }}</strong>
                    </div>
                    <div class="header__upn">
                      <strong>{{ 'tkey;search.ms_users.results.upn.header' | translate }}</strong>
                    </div>
                    <div class="microsoft-search-header__assigned-number">
                      <strong>{{ 'tkey;search.ms_users.results.assigned_number.header' | translate }}</strong>
                    </div>
                    <div class="microsoft-search-header__edit-btn"></div>
                  </div>

                  @for (result of microsoftEndUserResults; track result) {
                    <ziro-microsoft-search-result
                      data-automation="microsoft-search-result"
                      class="border-top btn btn-default border-0 border-radius-0 px-0"
                      [msResultType]="'user'"
                      (click)="handleResultClick(result.ref.id.includes('#EXT#'), result.ref.id)"
                      [ngStyle]="{
                        cursor: result.ref.id.includes('#EXT#') ? 'not-allowed' : 'pointer',
                      }"
                      [result]="result.ref"
                      [lineUri]="result.lineUri"
                      [lineUriExtension]="result.lineUriExtension"
                      [isLoadingLineUri]="isLoadingLineUri"
                      [photo]="result.photo"
                      [isPhotoLoading]="userPhotosLoading()"
                      [initials]="getUserInitialsFromDisplayName(result.ref.displayName)"
                      [isDisabled]="result.ref.id.includes('#EXT#')"
                      [disabledTooltip]="'tkey;search.ms_users.guest.disabled.tooltip'"
                    ></ziro-microsoft-search-result>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center" data-automation="no-results-info">
                  <strong>{{ 'tkey;search.no_results.info' | translate }}</strong>
                </div>
              }
            </ziro-collapsible-section-card>
          }

          @if (isCallQueueManagementAllowed) {
            <!-- Call Queues -->
            <ziro-collapsible-section-card
              [title]="'tkey;admin.teams_location_management.call_queues.title' | translate"
              [count]="callQueueResults?.length ?? 0"
              [icon]="ziroIcons.CALL_QUEUE"
              [hasLoadingState]="true"
              [isLoadingInput]="zpmResultsLoadingState.callQueueResultsLoading()"
              [dataAutomation]="'search-result-section-call-queues'"
              [isOpenInput]="
                zpmResultsLoadingState.callQueueResultsLoading() ||
                (!!callQueueResults?.length && callQueueResults.length > 0)
              "
              [isCollapsible]="true"
              [showChevron]="true"
            >
              @if (callQueueResults?.length > 0) {
                <div data-automation="call-queues-list" class="microsoft-search-table">
                  <div class="microsoft-search-table__header px-0 border-bottom btn border-0 text-start">
                    <div class="header__display-name">
                      <strong>{{ 'tkey;search.call_queues.results.displayname.header' | translate }}</strong>
                    </div>
                    <div class="header__upn"></div>
                    <div class="microsoft-search-header__assigned-number"></div>
                    <div class="microsoft-search-header__edit-btn"></div>
                  </div>

                  @for (callQueue of callQueueResults; let last = $last; track callQueue) {
                    <ziro-microsoft-search-result
                      data-automation="microsoft-search-result"
                      class="border-top btn btn-default border-0 px-0"
                      [msResultType]="'callQueue'"
                      (click)="handleCallQueueClick(callQueue.callQueueId)"
                      [ngStyle]="{ cursor: 'pointer' }"
                      [result]="getCallQueueResultAsMicrosoftUser(callQueue).ref"
                      [isLoadingLineUri]="false"
                      [showUpn]="false"
                      [showSearchResultIcon]="false"
                    ></ziro-microsoft-search-result>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center" data-automation="no-results-info">
                  <strong>{{ 'tkey;search.no_results.info' | translate }}</strong>
                </div>
              }
            </ziro-collapsible-section-card>
          }

          @if (isEmergencyLocationManagementAllowed) {
            <!-- Emergency Locations -->
            <ziro-collapsible-section-card
              [title]="'tkey;admin.teams_location_management.emergency_locations.title' | translate"
              [count]="emergencyLocationResults?.length ?? 0"
              [icon]="ziroIcons.EMERGENCY_LOCATION_SMALL"
              [hasLoadingState]="true"
              [isLoadingInput]="zpmResultsLoadingState.emergencyLocationResultsLoading()"
              [dataAutomation]="'search-result-section-emergency-locations'"
              [isOpenInput]="
                zpmResultsLoadingState.emergencyLocationResultsLoading() ||
                (!!emergencyLocationResults?.length && emergencyLocationResults.length > 0)
              "
              [isCollapsible]="true"
              [showChevron]="true"
            >
              @if (emergencyLocationResults.length > 0) {
                <div data-automation="emergency-locations-list" class="microsoft-search-table">
                  <div class="microsoft-search-table__header px-0 border-bottom btn border-0 text-start">
                    <div class="header__display-name">
                      <strong>{{ 'tkey;search.emergency_locations.location_places.label' | translate }}</strong>
                    </div>
                    <div class="header__address">
                      <strong>{{ 'tkey;search.emergency_locations.address.label' | translate }}</strong>
                    </div>
                    <div class="microsoft-search-header__edit-btn"></div>
                  </div>

                  <!-- Results -->
                  @for (location of emergencyLocationResults; track location; let last = $last) {
                    @let result = getLocationAsMicrosoft365UserRef(location);
                    <ziro-microsoft-search-result
                      data-automation="microsoft-search-result"
                      [msResultType]="'emergencyLocation'"
                      (click)="handleLocationClick(location.link)"
                      [ngStyle]="{ cursor: 'pointer' }"
                      class="border-top btn btn-default border-0 hide-assigned-number px-0"
                      [result]="result"
                      [isLoadingLineUri]="false"
                      [showUpn]="true"
                      [hideAssignedNumberCol]="true"
                      [charLimitUpn]="70"
                      [showSubLabel]="!!location.location"
                      [subLabel]="location.location"
                      [showSearchResultIcon]="false"
                    ></ziro-microsoft-search-result>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center" data-automation="no-results-info">
                  <strong>{{ 'tkey;search.no_results.info' | translate }}</strong>
                </div>
              }
            </ziro-collapsible-section-card>
          }

          @if (isAutoAttendantManagementAllowed) {
            <!-- Auto Attendants -->
            <ziro-collapsible-section-card
              [title]="'tkey;admin.teams_voice_management.teams_auto_attendant.title' | translate"
              [count]="autoAttendantResults?.length ?? 0"
              [icon]="ziroIcons.AUTO_ATTENDANT"
              [hasLoadingState]="true"
              [isLoadingInput]="zpmResultsLoadingState.autoAttendantResultsLoading()"
              [dataAutomation]="'search-result-section-auto-attendants'"
              [isOpenInput]="
                zpmResultsLoadingState.autoAttendantResultsLoading() ||
                (!!autoAttendantResults?.length && autoAttendantResults.length > 0)
              "
              [isCollapsible]="true"
              [showChevron]="true"
            >
              @if (autoAttendantResults?.length > 0) {
                <div data-automation="auto-attendants-list" class="microsoft-search-table">
                  <div class="microsoft-search-table__header px-0 border-bottom btn border-0 text-start">
                    <div class="header__display-name">
                      <strong>{{ 'tkey;search.auto_attendants.results.display_name.header' | translate }}</strong>
                    </div>
                    <div class="header__upn"></div>
                    <div class="microsoft-search-header__assigned-number"></div>
                    <div class="microsoft-search-header__edit-btn"></div>
                  </div>

                  @for (autoAttendant of autoAttendantResults; track autoAttendant.id) {
                    <ziro-microsoft-search-result
                      data-automation="microsoft-search-result"
                      class="border-top btn btn-default border-0 px-0"
                      [msResultType]="'autoAttendant'"
                      (click)="handleAutoAttendantClick(autoAttendant.id)"
                      [ngStyle]="{ cursor: 'pointer' }"
                      [result]="getAutoAttendantResultAsMicrosoftUser(autoAttendant).ref"
                      [isLoadingLineUri]="false"
                      [showUpn]="false"
                      [showSearchResultIcon]="false"
                      [isDisabled]="autoAttendant.teamsPhoneAgentEnabled"
                      [disabledTooltip]="'tkey;search.auto_attendants.disabled_tooltip'"
                    ></ziro-microsoft-search-result>
                  }
                </div>
              } @else {
                <div class="d-flex justify-content-center" data-automation="no-results-info">
                  <strong>{{ 'tkey;search.no_results.info' | translate }}</strong>
                </div>
              }
            </ziro-collapsible-section-card>
          }
        }
      }
    }
  </div>
</div>

<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
